import React, { useContext, FunctionComponent } from 'react';
import { Alert, Button } from 'antd';
import { UserContext } from 'contexts/UserContext';
import pageLanguage from 'language';

interface Props {
  visible: boolean;
}

/**
 * Avisa que ha um deploy novo no ar e deixa o reload a cargo do usuario.
 *
 * O reload nao desloga: a auth vive em sessionStorage (@cte:token / @cte:user), que
 * sobrevive a um reload na mesma aba, e UserContext so chama sessionStorage.clear()
 * dentro de logout().
 *
 * O botao vai dentro de `message` de proposito: a prop `action` do Alert so existe a
 * partir do antd 4.17 e este projeto esta no 4.15.1, onde ela seria ignorada em silencio.
 */
const NewVersionBanner: FunctionComponent<Props> = ({ visible }) => {
  const { language } = useContext(UserContext);

  if (!visible) return null;

  return (
    <Alert
      banner
      type="info"
      showIcon
      message={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 16,
            flexWrap: 'wrap',
          }}
        >
          <span>{pageLanguage.new_version_available[language]}</span>
          <Button size="small" type="primary" onClick={() => window.location.reload()}>
            {pageLanguage.reload_page[language]}
          </Button>
        </div>
      }
    />
  );
};

export default NewVersionBanner;
